import ChoixExpertLogo from './logo'
import {choixExpertStylesFR} from './styles'

const baseConfig = {
  domainName: 'choixexpert' as const,
  domainType: 'brg' as const,
  siteName: 'Choix Expert',
  favicon: '/favicons/choixexpert.png',
}

const localeConfigs = {
  fr: {
    measurementId: 'G-JKBT0BNKBZ',
    camelCaseUrl: 'ChoixExpert.fr',
    logo: <ChoixExpertLogo className="size-10 shrink-0 tablet:size-8" locale="fr" />,
    title: (category: string, _count: string) =>
      `Top ${category} - Comparatifs et Avis Experts pour Mieux Choisir - ChoixExpert`,
    description: (_category?: string, _count?: string) =>
      `Découvrez des comparatifs détaillés, des avis experts et des sélections fiables pour trouver facilement les meilleurs produits au meilleur prix.`,
    styles: choixExpertStylesFR,
  },
}

export const createConfig = (locale: string = 'fr') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.fr
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
